import { render, staticRenderFns } from "./index-material-us.vue?vue&type=template&id=00430b5a"
import script from "./index-material-us.vue?vue&type=script&lang=js"
export * from "./index-material-us.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports